import {
  ExtractFnReturnType,
  QueryConfigType,
  useQuery,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApiMembersEmployeeConditionSubmissionsSearchItemsResponseType } from "~/domains";

const request =
  async (): Promise<ApiMembersEmployeeConditionSubmissionsSearchItemsResponseType> => {
    const response =
      await new ApiClient().get<ApiMembersEmployeeConditionSubmissionsSearchItemsResponseType>(
        "/api/members/employee_condition_submissions_search_items",
      );
    return response.data;
  };

type QueryFnType = typeof request;

type PropsType = {
  config?: QueryConfigType<QueryFnType>;
};

export const useApisMembersEmployeeConditionSubmissionsSearchItemsIndex = ({
  config = {},
}: PropsType = {}): UseQueryResult<ApiMembersEmployeeConditionSubmissionsSearchItemsResponseType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisMembersEmployeeConditionSubmissionsSearchItemsIndex"],
    request,
    { ...config },
  );
};
